import React from 'react';
import { Route, Link, Switch, Redirect } from 'react-router-dom';
import * as Action from '../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import axios from 'axios';
import { fbFunctionsURL, serviceTracker_allowed } from '../../config.js';
import SchoolAdminStudent from '../../containers/SchoolAdminStudent';
import SchoolAdminTeacher from '../../containers/SchoolAdminTeacher';
import SchoolAdminClass from '../../containers/SchoolAdminClass';
import SchoolAdminSubject from '../../containers/SchoolAdminSubject';
import STAdminSchools from '../../containers/STAdminSchools';
import STAdminAdmins from '../../containers/STAdminAdmins';
import STAdminUsers from '../../containers/STAdminUsers';
import Login from '../../containers/Login';
import Register from '../../containers/Register';
import CreateUser from '../../containers/CreateUser';
import ThankYou from '../../containers/ThankYou';
import SideMenu from '../../components/SideMenu';
import SideMenuAdmin from '../../components/SideMenuAdmin';
import Nav from '../../components/Nav';
import NavSTAdmin from '../../components/NavSTAdmin';
import TopBar from '../../components/TopBar';
import GeneralInfo from '../../containers/GeneralInfo';
import ProgressOverview from '../../containers/ProgressOverview';
import TagOverview from '../../containers/TagOverview';
import IndividualProjects from '../../containers/IndividualProjects';
import CategoryOverview from '../../containers/CategoryOverview';
import SkillsOverview from '../../containers/SkillsOverview';
import CategorySpecs from '../../containers/CategorySpecs';
import SkillsLogged from '../../containers/SkillsLogged';
import TeacherProfile from '../../containers/TeacherProfile';
import SchoolSettings from '../../containers/SchoolSettings';
import Classes from '../../containers/Classes';
import StudentApp from '../../containers/StudentApp';
import ModalPassAndTerm from '../../containers/ModalPassAndTerm';
import Subscribe from '../../containers/Subscribe';
import { Layout, LocaleProvider } from 'antd';
import 'antd/dist/antd.css';
import '../../styles/styles.css';
import { firebaseConnect } from 'react-redux-firebase';
import { withRouter } from 'react-router';
import { pathOr } from 'ramda';
import fr_FR from 'antd/lib/locale-provider/fr_FR';
import en_GB from 'antd/lib/locale-provider/en_GB';
const { Sider, Content } = Layout;
const SkillTracker = 'SkillTracker';
const ServiceTracker = 'ServiceTracker';

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedProduct: '',
      exportData: null,
      didRedirect: false
    };
  }

  shouldAppRedirect = () => {
    if (
      this.props.location !== '/auth' &&
      this.props.location !== '/' &&
      this.props.location !== '/register' &&
      this.props.location !== '/subscribe'
    ) {
      return true;
    } else {
      return false;
    }
  };

  getExportData = clear => {
    return new Promise(resolve => {
      if (clear) {
        this.setState({ exportData: null });
      } else {
        const schoolId = this.props.profile.profile.school.id;
        this.props.firebase
          .auth()
          .currentUser.getIdToken()
          .then(token => {
            const config = {
              url: `${fbFunctionsURL}/register/teacherStats`,
              method: 'post',
              data: {
                schoolId
              },
              headers: {
                authorization: `Bearer ${token}`
              }
            };
            axios(config).then(response => {
              this.setState({ exportData: response.data }, () => resolve());
            });
          });
      }
    });
  };

  componentDidUpdate = prevProps => {
    // if (
    //   this.props.profile &&
    //   this.props.profile.roles &&
    //   Object.values(this.props.profile.roles)[0][0] == 'teacher' &&
    //   !this.state.selectedProduct
    // ) {
    //   if (
    //     this.props.location.includes('servicetracker') &&
    //     this.props.products &&
    //     this.props.products.includes('ServiceTracker')
    //   ) {
    //     this.selectProduct('ServiceTracker');
    //   } else {
    //     this.selectProduct('SkillTracker');
    //   }
    // }

    if (
      this.props.profile &&
      this.props.profile.language &&
      prevProps.profile.language !== this.props.profile.language
    ) {
      this.changeLanguage(this.props.profile.language);
    }
  };

  selectProduct = key => {
    const { firebase, profile } = this.props;
    const toChangePassword = pathOr(
      false,
      ['profile', 'changePassword'],
      profile
    );
    const termsAccepted = pathOr(false, ['profile', 'termsAccepted'], profile);
    console.log(toChangePassword, termsAccepted);
    if (!toChangePassword && termsAccepted) {
      const { uid } = this.props.auth;
      this.setState({ selectedProduct: key });
      firebase
        .database()
        .ref(`/users/${uid}/profile`)
        .update({
          lastUsed: key
        });
    }
  };

  // pushHistory = product => {
  //   console.log('push', product);
  //   if (product === 'SkillTracker') {
  //     this.props.history.push('/myclasses')
  //   } else {
  //     this.props.history.push('/servicetracker/progressoverview')
  //   }
  // }

  changeLanguage = lang => {
    const { i18n, firebase } = this.props;
    const { uid } = this.props.auth;
    i18n.changeLanguage(lang);
    firebase
      .database()
      .ref(`/users/${uid}`)
      .update({
        language: lang
      });
  };

  redirectTeacherToProduct = () => {
    const { profile, products } = this.props;
    if (!this.state.didRedirect) {
      this.setState({ didRedirect: true });
      //Haven't changed password yet
      if (
        (profile && !profile.profile.termsAccepted) ||
        profile.profile.changePassword
      ) {
        return <Redirect from="*" to="/" />;
      }
      //Did change password
      console.log('products', products);
      let product =
        products && products.length > 0 ? products[0] : 'SkillTracker';
      console.log('product0', product);
      if (
        profile &&
        profile.profile.lastUsed &&
        profile.profile.lastUsed == 'SkillTracker'
      ) {
        product = 'SkillTracker';
      } else if (
        profile &&
        profile.profile.lastUsed &&
        profile.profile.lastUsed == 'ServiceTracker'
      ) {
        product = 'ServiceTracker';
      }
      console.log('product1', product);
      if (product == 'SkillTracker') {
        this.selectProduct('SkillTracker');
        return <Redirect from="/" to="/myclasses" />;
      } else {
        this.selectProduct('ServiceTracker');
        return <Redirect from="/" to="/servicetracker/progressoverview" />;
      }
    }
  };

  render() {
    //Validation
    let role = null;
    const { auth, profile, products } = this.props;
    if (!auth || !auth.isLoaded) {
      return <div>Loading...</div>;
    }
    if (auth.uid == 'none') {
      this.props.firebase.logout();
    }
    if (profile.roles) {
      role = Object.values(profile.roles)[0][0];
    }
    if (!profile.roles) {
      role = null;
    }
    if (auth.email != 'stadmin@lizard-apps.com' && !auth.isEmpty && !role) {
      return <div>Loading...</div>;
    }
    const language = this.props.i18n.language;
    //This if statement is temporary until student web portal for accessing servicetracker get ready.
    // if (profile && !profile.token && role === 'student' && products.length == 1 && products.includes(ServiceTracker)) {
    //   this.props.firebase.logout();
    //   return <div>You do not have access to the web portal yet!  {this.shouldAppRedirect() && <Redirect to="/" />} </div>;
    // }
    //Logged out
    if (auth.isEmpty) {
      if (this.state.didRedirect) {
        this.setState({ didRedirect: false });
      }
      return (
        <div
          className="app"
          style={{ backgroundColor: '#EEF0F4', minHeight: '100vh' }}>
          <div
            style={{
              backgroundColor: 'white',
              height: '82px',
              marginBottom: '-82px'
            }}
          />
          <Switch>
            <Route
              exact
              path="/"
              render={() => <Login changeLanguage={this.changeLanguage} />}
            />
            <Route exact path="/auth" component={CreateUser} />
            <Route path="/register" component={Register} />
            <Route path="/subscribe" component={Subscribe} />
            {this.shouldAppRedirect() && <Redirect to="/" />} />}
          </Switch>
        </div>
      );
      // Logged in as ST admin
    } else if (auth.email == 'stadmin@lizard-apps.com') {
      return (
        <div
          className="app"
          style={{ backgroundColor: '#EEF0F4', minHeight: '100vh' }}>
          <Layout style={{ width: '100%' }}>
            <NavSTAdmin />
            <Content>
              <Route exact path="/" component={STAdminSchools} />
              <Route exact path="/admins" component={STAdminAdmins} />
              <Route exact path="/users" component={STAdminUsers} />
            </Content>
          </Layout>
        </div>
      );
      //Logged in as teacher
    } else if (role && role == 'teacher') {
      return (
        <LocaleProvider locale={language === 'FR' ? fr_FR : en_GB}>
          <div
            className="app"
            style={{ backgroundColor: '#F0F2F4', minHeight: '100vh' }}>
            <div
              style={{
                backgroundColor: 'white',
                height: '82px',
                marginBottom: '-82px',
                position: 'fixed',
                width: '100%',
                top: 0
              }}
            />

            <Layout
              style={{
                margin: '0 auto',
                maxWidth: 1300,
                backgroundColor: '#F0F2F4'
              }}>
              <Sider width="230">
                <SideMenu
                  location={this.props.location}
                  selectedProduct={this.state.selectedProduct}
                />
              </Sider>
              <Nav
                exportData={this.state.exportData}
                getExportData={this.getExportData}
                profile={this.props.profile}
                selectedProduct={this.state.selectedProduct}
                language={this.props.i18n.language}
                history={this.props.history}
                changeLanguage={this.changeLanguage}
                role="teacher"
                name={this.props.name}
                selectProduct={id => this.selectProduct(id)}
                products={this.props.products}
                active={
                  this.props.location == '/myclasses' ||
                  this.props.location == '/allclasses' ||
                  this.state.selectProduct == 'ServiceTracker'
                    ? false
                    : true
                }
                location={this.props.location}
              />
              <Layout>
                <Content style={{ paddingTop: 82 }}>
                  <TopBar
                    visibility={
                      this.props.location ==
                        '/servicetracker/progressoverview' ||
                      this.props.location == '/servicetracker/tagoverview'
                        ? false
                        : true
                    }
                    uid={this.props.auth.uid}
                    selectedProduct={this.state.selectedProduct}
                  />
                  {(this.props.location == '/' ||
                    this.props.location == '/auth') &&
                    this.redirectTeacherToProduct()}
                  <div>
                    <Switch>
                      <Route
                        exact
                        path="/"
                        render={() => (
                          <ModalPassAndTerm
                            resetRedirect={() =>
                              this.setState({ didRedirect: false })
                            }
                          />
                        )}
                      />
                      <Route path="/allclasses" component={Pages} />
                      <Route path="/myclasses" component={Pages} />
                      <Route path="/profile" component={TeacherProfile} />
                      <Route path="/school" component={Pages} />
                      <Route
                        path="/servicetracker"
                        component={ServiceTrackerPages}
                      />
                      <Route
                        path="/tagoverview"
                        component={ServiceTrackerPages}
                      />
                      <Route
                        path="/individualprojects"
                        component={ServiceTrackerPages}
                      />
                    </Switch>
                  </div>
                </Content>
              </Layout>
            </Layout>
          </div>
        </LocaleProvider>
      );
      //Logged in as school admin
    } else if (role == 'admin') {
      return (
        <LocaleProvider locale={language === 'FR' ? fr_FR : en_GB}>
          <div
            className="app"
            style={{ backgroundColor: '#EEF0F4', minHeight: '100vh' }}>
            <div
              style={{
                backgroundColor: 'white',
                height: '82px',
                marginBottom: '-82px'
              }}
            />
            <Layout style={{ margin: '0 auto' }}>
              <Sider width="230">
                <SideMenuAdmin />
              </Sider>
              <Layout>
                <Nav
                  active={false}
                  role="admin"
                  changeLanguage={this.changeLanguage}
                  location={this.props.location}
                />
                <Content>
                  <TopBar visibility={false} />
                  <div>
                    <Route
                      exact
                      path="/student"
                      render={() => <SchoolAdminStudent table="student" />}
                    />
                    <Route
                      exact
                      path="/"
                      render={() => <SchoolAdminStudent table="student" />}
                    />
                    <Route
                      exact
                      path="/teacher"
                      render={() => <SchoolAdminTeacher table="teacher" />}
                    />
                    <Route
                      exact
                      path="/subject"
                      render={() => <SchoolAdminSubject />}
                    />
                    <Route
                      exact
                      path="/school-settings"
                      component={SchoolSettings}
                    />
                    <Route exact path="/class" component={SchoolAdminClass} />
                  </div>
                </Content>
              </Layout>
            </Layout>
          </div>
        </LocaleProvider>
      );
    } else {
      return (
        <LocaleProvider locale={language === 'FR' ? fr_FR : en_GB}>
          <div
            style={{
              backgroundColor: '#EEF0F4',
              minHeight: '100vh',
              overflowY: 'overlay'
            }}>
            <Switch>
              <Route
                exact
                path="/"
                render={() => (
                  <StudentApp changeLanguage={this.changeLanguage} />
                )}
              />
              <Route exact path="/welcome" component={ThankYou} />
            </Switch>
          </div>
        </LocaleProvider>
      );
    }
  }
}
const Pages = ({ match }) => (
  <div>
    <Route exact path={`${match.url}`} component={Classes} />
    <Route exact path={`${match.url}/generalinfo`} component={GeneralInfo} />
    <Route exact path={`${match.url}/overview`} component={CategoryOverview} />
    <Route exact path={`${match.url}/specs`} component={CategorySpecs} />
    <Route
      exact
      path={`${match.url}/skillsoverview`}
      component={SkillsOverview}
    />
    <Route exact path={`${match.url}/skills`} component={SkillsLogged} />
  </div>
);
const ServiceTrackerPages = ({ match }) => (
  <div>
    <Route exact path={`${match.url}`} component={ProgressOverview} />
    <Route
      exact
      path={`${match.url}/progressoverview`}
      component={ProgressOverview}
    />
    <Route exact path={`${match.url}/tagoverview`} component={TagOverview} />
    <Route
      exact
      path={`${match.url}/individualprojects`}
      component={IndividualProjects}
    />
  </div>
);
const enhancer = compose(
  firebaseConnect(props => {}),
  connect(state => ({
    auth: state.firebase && state.firebase.auth,
    profile: state.firebase.profile,
    authError: state.firebase && state.firebase.authError,
    location: state.router.location.pathname,
    products: pathOr(
      ['SkillTracker'],
      ['profile', 'profile', 'products'],
      state.firebase
    ),
    name:
      state.firebase.profile.profile &&
      state.firebase.profile.profile.name +
        ' ' +
        state.firebase.profile.profile.last_name
  }))
);
export default withRouter(enhancer(App));



// WEBPACK FOOTER //
// ./src/containers/App/index.js